<template>
    <div class="form-group row" v-bind:class="{ 'has-danger' : form.errors.has(name) }">
        <label v-if="type != 'hidden'" :class="labelClasses" class="col-form-label" :for="name">{{ labelText }}</label>
        <div :class="inputHolderClasses">
            <div v-show="loading" class="input__spinner"></div>
            <input
                :type="type"
                :autofocus="autofocus"
                class="form-control"
                :id="name"
                :name="name"
                v-model="form[name]"
                :required="required"
                @change="emitValueChange(name)"
                @blur="emitBlur"
                @keydown="emitKeyDown"
                v-bind="$attrs"
            >
            <span class="help-block form-control-feedback" v-if="help_text != '' && !form.errors.has(name)" v-text="help_text"></span>
            <span class="help-block form-control-feedback" v-if="form.errors.has(name)" v-text="form.errors.get(name)"></span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'form-input',

        props: {
            autofocus: {
                type: Boolean,
                default: false,
            },
            emitChange: {
                default: false
            },
            form: {
                required: true,
            },
            help_text: {
                type: String,
                default: ''
            },
            inputHolderClasses: {
                type: String,
                required: false,
                default: 'col-md-9 col-xl-10 col-sm-12'
            },
            label: {
                type: String,
                required: false,
                default: null
            },
            labelClasses: {
                type: String,
                required: false,
                default: 'col-md-3 col-xl-2 col-sm-12'
            },
            loading: {
                type: Boolean,
                required: false,
                default: false,
            },
            name: {
                type: String,
                required: true,
            },
            required: {
                type: Boolean,
                default: false,
            },
            type: {
                type: String,
                default: 'text',
            },
        },

        data() {
            return {
            }
        },

        computed: {
            labelText: function () {
                return this.uLang('app.' + (this.label || this.name)) + (this.required ? ': *' : ': ');
            }
        },

        methods: {
            emitValueChange(name){
                this.$emit('inputChanged', name);
            },

            emitBlur(value) {
                this.$emit('blur', name);
            },

            emitKeyDown(value) {
                this.$emit('keydown', name);
            },
        }
    }
</script>

<style lang="css" scoped>
</style>
